import { createRequestPayloadForPersonal } from './createRequestPayload';
import {
  fetchCreatePersonalMessage,
  ICreatePersonalMessageResponse200,
  ICreatePersonalMessageResponse400,
} from '../../../repositories/demand/v2/create-personal-message';
import { TMappedAnswersState } from '../types';
import { IHttpApi } from '@cian/http-api/shared/http';
import { selectPage } from '../../../selectors/selectPage';
import { IApplicationState } from '../../../types/redux';
import { selectIsWebview } from '../../../selectors/selectIsWebview';

interface IParams {
  httpApi: IHttpApi;
  mappedAnswersState: TMappedAnswersState;
  state: IApplicationState;
}

export const createPersonalRequest = async (params: IParams) => {
  const { httpApi, mappedAnswersState, state } = params;
  const isWebview = selectIsWebview(state);
  const {
    platform,
    queryParams: { cian_source },
  } = selectPage(state);
  const parameters = createRequestPayloadForPersonal({ platform, isWebview, mappedAnswersState, cian_source });

  return fetchCreatePersonalMessage<ICreatePersonalMessageResponse200, ICreatePersonalMessageResponse400>({
    httpApi,
    parameters,
  });
};
